import type { EditorState } from "../../vendor/src/features/remotion-editor/editor/state/types";
import { insertTimelineTime } from "./timeline-insert";

export type PlacementSpan = { trackId: string; from: number; duration: number };
/** Shared by a real drop and its display-only projection; filling a gap never opens time. */
export function openPlacementSpace(
  state: EditorState,
  spans: readonly PlacementSpan[],
  primaryTrackId: string,
) {
  const fail = () => ({ ok: false, state, inserted: false });
  if (
    !spans.length ||
    spans.some(
      (s) =>
        !Number.isSafeInteger(s.from) ||
        s.from < 0 ||
        !Number.isSafeInteger(s.duration) ||
        s.duration < 1 ||
        !Number.isSafeInteger(s.from + s.duration),
    )
  )
    return fail();
  const tracks = state.undoableState.tracks;
  if (spans.some((s) => !tracks.some((t) => t.id === s.trackId && !t.locked)))
    return fail();
  const occupied = tracks.filter((t) =>
    spans.some(
      (s) =>
        s.trackId === t.id &&
        t.items.some((id) => {
          const i = state.undoableState.items[id];
          return (
            i &&
            s.from < i.from + i.durationInFrames &&
            i.from < s.from + s.duration
          );
        }),
    ),
  );
  if (!occupied.length) return { ok: true, state, inserted: false };
  const magnetic = occupied.filter((t) => t.magnetic);
  if (!magnetic.length) return fail();
  const main = magnetic.find(
    (t) =>
      t.id === primaryTrackId &&
      t.metadata?.isMainTrack &&
      t.metadata.type === "video",
  );
  const scope =
    state.isLinkingEnabled && main ? tracks.filter((t) => !t.locked) : magnetic;
  if (occupied.some((t) => !scope.includes(t))) return fail();
  const from = Math.min(...spans.map((s) => s.from));
  const end = Math.max(...spans.map((s) => s.from + s.duration));
  const result = insertTimelineTime(
    state,
    scope.map((t) => t.id),
    from,
    end - from,
    [],
    { crossingVisuals: "split" },
  );
  return { ...result, inserted: result.ok };
}
